export enum ImageSize {
  None = 'none',
  LG = 'lg',
  RG = 'rg',
  MD = 'md',
  SM = 'sm',
}

export type ImageWidthOrHeight = `${number}px` | `${number}%` | 'auto' | 'fit-content' | null | undefined;
